<script lang="ts">
import { Money } from '@commercetools/platform-sdk';
import { dollars } from '@nuts/auto-delivery-sdk/dist/utils/money';
import { PayPalTokenizePayload } from 'braintree-web';
import { computed, defineComponent, onMounted, PropType, ref } from 'vue';

export default defineComponent({
  name: 'BraintreePaypalButton',
  props: {
    amount: { required: true, type: Object as PropType<Money> },
    autoSetDataUserIdToken: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: { type: Object as PropType<PayPalTokenizePayload> },
  },
  emits: ['error', 'submit', 'update:modelValue'],
  setup(props, { emit }) {
    const classes = computed(() => (props.disabled ? 'opacity-50 pointer-events-none' : ''));
    const el = ref<HTMLElement>();

    onMounted(async () => {
      if (!el.value) {
        throw new Error('no el after mount?');
      }
      const { useBraintree } = await import('@/stores/braintree');
      const braintreeStore = useBraintree();
      const paypalCheckout = await braintreeStore.initPayPal(props.autoSetDataUserIdToken);

      window.paypal
        .Buttons({
          fundingSource: 'paypal',
          style: { label: 'pay' },
          createOrder() {
            return paypalCheckout.createPayment({
              amount: dollars(props.amount),
              currency: 'USD',
              flow: 'checkout' as any as typeof window.paypal.FlowType.Checkout,
              intent: 'authorize' as any as typeof window.paypal.Intent.Authorize,
              requestBillingAgreement: true,
              shippingAddressEditable: false,
            });
          },
          async onApprove(data) {
            const payload = await paypalCheckout.tokenizePayment(data);
            payload.nonce = `paypal_account:${payload.nonce}`;
            emit('update:modelValue', payload);
            emit('submit');
            // TODO: Await placeOrder in here, to keep the paypal Processing screen open?
          },
          onError(error) {
            // TODO: Handle/report errors better
            console.error('error', error);
            emit('error', error);
          },
        })
        .render(el.value);
    });

    return { classes, el };
  },
});
</script>

<template>
  <div ref="el" class="h-10 md:h-12" :class="classes" />
</template>
